import {
  WIZARD_CREATE_GWS_ADMIN,
  WIZARD_CREATE_TENANT,
  WIZARD_ENABLE_DMARC,
  WIZARD_ENABLE_GWS,
  WIZARD_FETCH_FAILED_MAILBOXES,
  WIZARD_FETCH_GROUPS,
  WIZARD_FETCH_STATUS,
  WIZARD_GET_SETTINGS_OPTIONS,
  WIZARD_RESET,
  WIZARD_RESUME_SESSION,
  WIZARD_SAVE_SETTINGS,
  WIZARD_SET_PROVIDER,
  WIZARD_SET_STEP,
  WIZARD_TRIGGER_SYNC,
} from './constants'

export const wizardCreateTenant = (data) => WIZARD_CREATE_TENANT.initiate(data)
export const wizardCreateTenantSuccess = (data) => WIZARD_CREATE_TENANT.onSuccess(data)
export const wizardCreateTenantError = (error) => WIZARD_CREATE_TENANT.onError(error)

export const wizardFetchStatus = (companyId) => WIZARD_FETCH_STATUS.initiate({ companyId })
export const wizardFetchStatusSuccess = (data) => WIZARD_FETCH_STATUS.onSuccess(data)
export const wizardFetchStatusError = (error) => WIZARD_FETCH_STATUS.onError(error)

export const wizardTriggerSync = (companyId, data) =>
  WIZARD_TRIGGER_SYNC.initiate({ companyId, ...data })
export const wizardTriggerSyncSuccess = (data) => WIZARD_TRIGGER_SYNC.onSuccess(data)
export const wizardTriggerSyncError = (error) => WIZARD_TRIGGER_SYNC.onError(error)

export const wizardGetSettingsOptions = (companyId) =>
  WIZARD_GET_SETTINGS_OPTIONS.initiate({ companyId })
export const wizardGetSettingsOptionsSuccess = (data) => WIZARD_GET_SETTINGS_OPTIONS.onSuccess(data)
export const wizardGetSettingsOptionsError = (error) => WIZARD_GET_SETTINGS_OPTIONS.onError(error)

export const wizardSaveSettings = (companyId, data) =>
  WIZARD_SAVE_SETTINGS.initiate({ companyId, ...data })
export const wizardSaveSettingsSuccess = (data) => WIZARD_SAVE_SETTINGS.onSuccess(data)
export const wizardSaveSettingsError = (error) => WIZARD_SAVE_SETTINGS.onError(error)

export const wizardEnableDmarc = (companyId, data) =>
  WIZARD_ENABLE_DMARC.initiate({ companyId, ...data })
export const wizardEnableDmarcSuccess = (data) => WIZARD_ENABLE_DMARC.onSuccess(data)
export const wizardEnableDmarcError = (error) => WIZARD_ENABLE_DMARC.onError(error)

export const wizardSetStep = (step) => ({ type: WIZARD_SET_STEP, payload: { step } })
export const wizardSetProvider = (provider) => ({
  type: WIZARD_SET_PROVIDER,
  payload: { provider },
})
export const wizardResumeSession = ({ companyId, step, provider } = {}) => ({
  type: WIZARD_RESUME_SESSION,
  payload: { companyId, step, provider },
})
export const wizardReset = () => ({ type: WIZARD_RESET })

export const wizardFetchGroups = (companyId, refresh = false) =>
  WIZARD_FETCH_GROUPS.initiate({ companyId, refresh })
export const wizardFetchGroupsSuccess = (data) => WIZARD_FETCH_GROUPS.onSuccess(data)
export const wizardFetchGroupsError = (error) => WIZARD_FETCH_GROUPS.onError(error)

export const wizardFetchFailedMailboxes = (companyId) =>
  WIZARD_FETCH_FAILED_MAILBOXES.initiate({ companyId })
export const wizardFetchFailedMailboxesSuccess = (data) =>
  WIZARD_FETCH_FAILED_MAILBOXES.onSuccess(data)
export const wizardFetchFailedMailboxesError = (error) =>
  WIZARD_FETCH_FAILED_MAILBOXES.onError(error)

export const wizardCreateGwsAdmin = (companyId, data) =>
  WIZARD_CREATE_GWS_ADMIN.initiate({ companyId, ...data })
export const wizardCreateGwsAdminSuccess = (data) => WIZARD_CREATE_GWS_ADMIN.onSuccess(data)
export const wizardCreateGwsAdminError = (error) => WIZARD_CREATE_GWS_ADMIN.onError(error)

export const wizardEnableGws = (companyId) => WIZARD_ENABLE_GWS.initiate({ companyId })
export const wizardEnableGwsSuccess = (data) => WIZARD_ENABLE_GWS.onSuccess(data)
export const wizardEnableGwsError = (error) => WIZARD_ENABLE_GWS.onError(error)
